module.exports = __webpack_public_path__ + "img/7-white.6c9ffae4.png";